import LearnPageLayout from "@/components/LearnPageLayout";
import { pageWhatIsAcceleratedTms } from "./learnDataWhatIsAcceleratedTms";

const WhatIsAcceleratedTmsPage = () => (
  <LearnPageLayout
    title={pageWhatIsAcceleratedTms.title}
    description={pageWhatIsAcceleratedTms.description}
    canonical={pageWhatIsAcceleratedTms.canonical}
    h1={pageWhatIsAcceleratedTms.h1}
    breadcrumbLabel={pageWhatIsAcceleratedTms.breadcrumbLabel}
    crumbs={pageWhatIsAcceleratedTms.crumbs}
    shortAnswer={pageWhatIsAcceleratedTms.shortAnswer}
    keyTakeaways={pageWhatIsAcceleratedTms.keyTakeaways}
    sections={pageWhatIsAcceleratedTms.sections}
    faqs={pageWhatIsAcceleratedTms.faqs}
    sources={pageWhatIsAcceleratedTms.sources}
    schemaJson={pageWhatIsAcceleratedTms.schemaJson}
    relatedLinks={pageWhatIsAcceleratedTms.relatedLinks}
    reviewBlock={pageWhatIsAcceleratedTms.reviewBlock}
    toc={pageWhatIsAcceleratedTms.toc}
    safetyBlock={pageWhatIsAcceleratedTms.safetyBlock}
    trademarkFooter={pageWhatIsAcceleratedTms.trademarkFooter}
    ctaBand={pageWhatIsAcceleratedTms.ctaBand}
  />
);

export default WhatIsAcceleratedTmsPage;
